const notifications = {
  moduleTitle: "Notifications",
  title: "Notifications",
  markAllAsRead: "Mark all as read",
  empty: "You have no notifications yet.",
  error: "Notifications could not be loaded.",
  loading: "Loading notifications",
  bellLabelWithCount: "Notifications, {{count}} unread",
  enablePush: "Enable push notifications",
  category: {
    alert: "Alert",
    system: "System",
    subscription: "Subscription",
    maintenance: "Maintenance",
  },
  permissions: {
    core: "Core",
    management: "Notification management",
    notifications: "Notifications",
  },
  actions: {
    view: "View notifications",
  },
};

export default notifications;
